import { Button } from '@efexteam/components';
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface WelcomeProps {
  goBack: () => void;
  nextStep: () => void;
}

const Welcome = ({ goBack, nextStep }: WelcomeProps) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">{t('tfConfigTitle')}</Typography>
        <List>
          <ListItem>
            <ListItemIcon className="rounded-full bg-[#00143A] !text-white font-bold !w-[30px] !h-[30px] !min-w-[unset] p-3 items-center justify-center mr-4">
              1
            </ListItemIcon>
            <ListItemText>
              <Typography variant="subtitle2">{t('tfConfigStep1')}</Typography>
              <Typography variant="caption">
                {t('tfConfigStep1Description')}
              </Typography>
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon className="rounded-full bg-[#00143A] !text-white font-bold !w-[30px] !h-[30px] !min-w-[unset] p-3 items-center justify-center mr-4">
              2
            </ListItemIcon>
            <ListItemText>
              <Typography variant="subtitle2">{t('tfConfigStep2')}</Typography>
              <Typography variant="caption">
                {t('tfConfigStep2Description')}
              </Typography>
            </ListItemText>
          </ListItem>
        </List>
        <div className="flex justify-around gap-3">
          <Button appearance="secondary" onClick={goBack}>
            {t('back')}
          </Button>
          <Button appearance="primary" onClick={nextStep}>
            {t('continue')}
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default Welcome;
